module.exports = __webpack_public_path__ + "static/media/Arrow.923ae1e3.jpg";